import { memo, forwardRef, useMemo, useEffect, useCallback, useState, useRef } from 'react';
import { Col, Row, Container, Dropdown, FormControl } from 'react-bootstrap';
import { BzChip, BzToastMessage, BzMasterAgGrid } from '../../../components';
import FilterModal from "./FilterModal";
import { MUTUAL_FUNDS_WATCHLIST_GRID, setMutualFundsWatchlistGrid } from '../../../utils/global_functions';
import CreateCustomWatchListModal from '../Watchlist/CreateCustomWatchListModal';
import { ConfirmationModal, EmptyWatchlistModal } from '../Watchlist';
import { handleModal } from "../../../redux/actions/modals";
import { useDispatch, useSelector } from 'react-redux';
import { getMfColumnDef, createMutualFundProfile, updateMutualFundWatchlist, deleteMutualFundProfile } from '../../../redux/actions/mutualFund';
import { MF_WATCHLIST_GRID_INDEX, setStrSearch } from '../../../utils/global_variables';
import GridHeaderSearch from '../../GridHeaderSearch';



const Watchlist = ({ onGridReady, onRowDragEnd, btnClickHandler, onRowSelected, onRemoveFunds, themes, nfo, mutualFund, isShow, setIsShow, fundList, setFundList, selectedValue, arrWatchlist, setArrWatchlist, activeFilters, setActiveFilters, handleFiltersOnClick, handleOnFilterApply, isselected, setSelected, kababDropdownoptionsOnClickHandler, SetreorderWachlist, isreorderWatchlist, currentWatchListName, setCurrentWatchListName, arrKababDropdown, removeFunds, setRemoveFunds, toasterMsgConfig, setToasterMsgConfig, showRemoveFundModal, setShowRemoveFundModal, handleAddFunds, ...props }) => {

    const dispatch = useDispatch();
    setMutualFundsWatchlistGrid(useRef());


    const onChangeGridHeaderSearch = useCallback((e) => {
        setStrSearch(e?.target?.value);
        //console.log(MUTUAL_FUNDS_WATCHLIST_GRID?.current?.api?.onFilterChanged);
        MUTUAL_FUNDS_WATCHLIST_GRID?.current?.api?.onFilterChanged();
    }, []);




    const [mutualFundsScrips, setMutualFundsScrips] = useState([]);
    const [rowOrder, setRowOrder] = useState([]);

    const modals = useSelector(state => state?.modals?.modals);
    const watchList = useSelector(state => state.mutualFund.watchList);
    const mfColumnDef = useSelector(state => state?.mutualFund.mfColumnDef);



    const onMfWatchlistGridRowDragEnd = useCallback((event) => {//this function set data of row drag event every time
        const { api } = event;
        const scripsAfterRowDrag = api?.getModel().rowsToDisplay.map((rowNode) => rowNode.data);
        setRowOrder(scripsAfterRowDrag);
    }, []);


    useEffect(() => {
        if (watchList?.data?.length > 0) {
            setMutualFundsScrips([...watchList?.data]);
        }
    }, [watchList]);

    // const updateReorderedFunds = useCallback(() => {
    //     if (rowOrder?.length <= 0) {
    //         dispatch(toastConfig({ autoDismiss: true, show: true, message: `No changes were done in this watchlist` }));
    //         setTimeout(() => {
    //             dispatch(toastConfig({ show: true, message: `Reorder scrips in ${watchList?.name}`, button: [{ btnName: "Done", type: "REORDER_MF_FUNDS", className: "btn btn-outline-active ms-3" }] }));
    //         }, 2000);
    //     }
    //     else {
    //         const arrSchemes = rowOrder.map((eachFund) => ({
    //             exchange_code: eachFund.exchange_code,
    //             scheme_code: eachFund.scheme_code
    //         }));
    //         let mutualFundProfile = watchList?.mutualFundProfile;
    //         const payload = { data: [...rowOrder], name: mutualFundProfile.profile_name, mutualFundProfile: watchList.mutualFundProfile };
    //         const objcreateProfilePayload = {
    //             profile_id: mutualFundProfile.profile_id,
    //             profile_name: mutualFundProfile.profile_name,
    //             default_type: mutualFundProfile.is_default,
    //             update_type: 'R',
    //             scheme_list: arrSchemes
    //         };
    //         dispatch(createMutualFundProfile(objcreateProfilePayload));
    //         dispatch(updateMutualFundWatchlist(payload));
    //         setMutualFundsScrips(rowOrder);
    //         MUTUAL_FUNDS_WATCHLIST_GRID.current.api.setGridOption('rowDrag', true);
    //         MUTUAL_FUNDS_WATCHLIST_GRID?.current?.api.forEachNode((node) => {
    //             node.setSelected(false);
    //         });
    //     }
    //     dispatch(toastConfig({}));

    // }, [watchList, rowOrder]);

    // const allMutualFunds = [...nfo, ...mutualFund].filter(fund => isFundPresent(fund.id));
    if (nfo?.length > 0 && mutualFund?.length > 0) {
        var allMutualFunds = [...nfo, ...mutualFund];
    } else {
        allMutualFunds = [...mutualFund];
    }

    const CustomDropdownToggle = forwardRef(({ children, onClick }, ref) => (
        <div
            ref={ref}
            onClick={(e) => {
                e.preventDefault();
                onClick(e);
            }}
        >
            {children}
        </div>
    ));
    const handleOnWatchlistFilter = () => {
        dispatch(handleModal([{ "FILTER_MODAL": true }]));
    };


    const arrMutualFundWatchlistColDefs = useMemo(() => {
        const arrMutualFundWatchlistColDefs = mfColumnDef.map(item => {
            switch (item.field) {
                case MF_WATCHLIST_GRID_INDEX.SYMBOL:
                    item = {
                        ...item, headerComponent: GridHeaderSearch,
                        headerComponentParams: { onChangeGridHeaderSearch, gridRef: MUTUAL_FUNDS_WATCHLIST_GRID },
                        pinned: 'left', rowDrag: true, width: 350,
                    };
                    return item;
                case MF_WATCHLIST_GRID_INDEX.NAV:
                    return item;
                default:
                    return item;
            }
        });
        return arrMutualFundWatchlistColDefs;
    }, [mfColumnDef]);

    useEffect(() => {
        dispatch(getMfColumnDef());
    }, [dispatch]);

    const onRemoveConfirmation = useCallback(() => {
        let scripsCopy = mutualFundsScrips;
        let selectedFunds = MUTUAL_FUNDS_WATCHLIST_GRID?.current?.api?.getSelectedRows();
        selectedFunds?.forEach((removeScrip) => {
            scripsCopy?.forEach((obj, index) => {
                if (removeScrip?.exchange_code === obj.exchange_code && removeScrip?.scheme_code === obj.scheme_code) {
                    scripsCopy?.splice(index, 1);
                }
            });
        });

        const arrSchemes = scripsCopy.map((eachFund) => ({
            exchange_code: eachFund.exchange_code,
            scheme_code: eachFund.scheme_code
        }));
        let mutualFundProfile = watchList.mutualFundProfile;
        const payload = { data: [...scripsCopy], name: mutualFundProfile.profile_name, mutualFundProfile: watchList.mutualFundProfile };
        const objcreateProfilePayload = {
            profile_id: mutualFundProfile.profile_id,
            profile_name: mutualFundProfile.profile_name,
            default_type: mutualFundProfile.is_default,
            update_type: 'R',
            scheme_list: arrSchemes
        };
        dispatch(createMutualFundProfile(objcreateProfilePayload));
        dispatch(updateMutualFundWatchlist(payload));
        setMutualFundsScrips(scripsCopy);
        dispatch(handleModal([{ 'REMOVE_FUNDS_MODAL': false }]));
    }, [mutualFundsScrips, watchList, dispatch]);



    const onRenameWatchlist = (name) => {
        dispatch(handleModal([{ "RENAME_WATCHLIST": false }]));
        setToasterMsgConfig({ isShow: true, isButton: true, msg: 'WatchList renamed successfully', btnContent: 'ok' });
    };

    const onDeleteWatchlist = () => {
        dispatch(deleteMutualFundProfile(watchList?.mutualFundProfile?.profile_id));
        dispatch(updateMutualFundWatchlist({}));
        setMutualFundsScrips([]);
        dispatch(handleModal([{ "DELETE_WATCHLIST": false }]));
        setToasterMsgConfig({ isShow: true, isButton: true, msg: 'WatchList Deleted successfully', btnContent: 'ok' });
        dispatch(handleModal([{ "ADD_FUND_MODAL": false }]));

    };

    

    return (
        <>

            {watchList?.data?.length ?
                <>
                    <Container fluid className='p-0'>
                        <Row className='g-0 mb-4'>
                            <Col md={7}>
                                <Row className='g-0'>
                                    <Col md={4}>
                                        <div className='searchbar-wrap'>
                                            <div className='searchbox'>
                                                <div className='searchicon-wrap'>
                                                    <div className='icon-14 icon-search icon-grey'></div>
                                                </div>
                                                <FormControl size='sm' id='watchlist_search' type='search' className='font-regular font-size3 scripname-searchtext' placeholder={`Search Tax Saver Funds... ${watchList?.name || ""}`} />
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md={6} className='d-flex align-items-center'>
                                        <div className='font-regular font-size4 text-secondary ms-3'>{watchList?.data?.length} funds shortlisted . . . </div>
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={5} className='d-flex justify-content-end align-items-center'>
                                <Row className='g-0 w-100'>
                                    <Col className='d-flex justify-content-end align-items-center'>
                                        <div className='d-flex justify-content-end align-items-center' onClick={handleAddFunds}>
                                            <div className='font-medium font-size4 color-text'>Add fund</div>
                                            <div className='icon-16 icon-add-circle-fill icon-dark ms-2'>&nbsp;</div>
                                        </div>
                                    </Col>
                                    <Col md={1} className='d-flex justify-content-end align-items-center'>
                                        <div onClick={() => { }} className='icon-14 icon-filter icon-dark'>&nbsp;</div>
                                    </Col>
                                    <Col md={1} className='d-flex justify-content-end align-items-center'>
                                        <Dropdown className='dropdown-kebab'>
                                            <Dropdown.Toggle as={CustomDropdownToggle} className='p-0 m-0'>
                                                <div className='icon-14 icon-kebab icon-dark'></div>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                {
                                                    arrKababDropdown.map((eachOption) => (
                                                        <Dropdown.Item key={eachOption.id} value={eachOption.value} onClick={(e) => kababDropdownoptionsOnClickHandler(e, eachOption.value)}>
                                                            <Row className='g-0' >
                                                                <Col md={eachOption?.shortcut ? 7 : 12} className='d-flex justify-content-start align-self-center'>
                                                                    <div className='text-nowrap text-truncate'>{eachOption.content}</div>
                                                                </Col>
                                                            </Row>
                                                        </Dropdown.Item>
                                                    ))
                                                }
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Container>
                    {selectedValue?.length ?
                        <Row className='g-0 pb-3'>
                            <div className='chips-wrap flex-wrap'>
                                Filters:- {selectedValue?.map((categoryName, i) => <BzChip key={i} className='chips primary-chip me-2 mt-1'>{categoryName}</BzChip>)}
                            </div>
                        </Row>
                        :
                        null
                    }

                    <BzMasterAgGrid  ref={MUTUAL_FUNDS_WATCHLIST_GRID} rowHeight={70} detailRowAutoHeight={true} className='ag-theme-alpine mf-watchlist-ag-grid-wrapper' arrColumnData={arrMutualFundWatchlistColDefs} arrRowData={watchList?.data} rowDragManaged={false} onGridReady={onGridReady} onRowDragEnd={onMfWatchlistGridRowDragEnd} rowSelection={'multiple'} onRowSelected={onRowSelected} />

                    <FilterModal
                        activeFilters={activeFilters}
                        setActiveFilters={setActiveFilters}
                        handleFiltersOnClick={handleFiltersOnClick}
                        handleOnFilterApply={handleOnFilterApply} />

                    <CreateCustomWatchListModal mutualFund={allMutualFunds} currentWatchListName={currentWatchListName} setCurrentWatchListName={setCurrentWatchListName} fundList={fundList} setFundList={setFundList} mutualFundsScrips={mutualFundsScrips} setMutualFundsScrips={setMutualFundsScrips} />

                    <ConfirmationModal
                        isShow={modals['DELETE_WATCHLIST']}
                        setIsShow={() => dispatch(handleModal([{ "DELETE_WATCHLIST": false }]))}
                        activeWatchList={watchList}
                        onDeleteWatchlist={onDeleteWatchlist}
                        headerText='Delete Watchlist'
                        bodyText={` Are you sure you want to delete the watchlist ':${watchList?.name}`}
                        isButton={true}
                        buttonData={[{ label: 'CANCEL', action: () => { dispatch(handleModal([{ "DELETE_WATCHLIST": false }])); } }, { label: 'YES ,DELETE', action: onDeleteWatchlist }]}
                    />

                    <ConfirmationModal isShow={modals['REMOVE_FUNDS_MODAL']} setIsShow={() => dispatch(handleModal([{ 'REMOVE_FUNDS_MODAL': false }]))} headerText='Remove Funds' bodyText={`Are you sure you want to delete '${MUTUAL_FUNDS_WATCHLIST_GRID?.current?.api?.getSelectedRows().length}' funds from '${watchList?.name}' ?`} isButton={true} buttonData={[{ label: 'CANCEL', action: () => { dispatch(handleModal([{ 'REMOVE_FUNDS_MODAL': false }])); setRemoveFunds(false); MUTUAL_FUNDS_WATCHLIST_GRID?.current?.columnApi?.setColumnVisible(MUTUAL_FUNDS_WATCHLIST_GRID?.current?.columnApi?.columnModel?.columnDefs[0]?.colId, false); } }, { label: 'REMOVE', action: onRemoveConfirmation }]} />

                    <ConfirmationModal
                        isShow={modals['RENAME_WATCHLIST']}
                        setIsShow={() => { dispatch(handleModal([{ "RENAME_WATCHLIST": false }])); }}
                        activeWatchList={watchList}
                        onRenameWatchlist={onRenameWatchlist}
                        headerText='Rename Watchlist'
                        bodyText={`Current Watchlist name`}
                        bodySubText={`${watchList?.name}(${watchList?.data?.length})`}
                        isInputBox={true}
                        inputLabel='Rename Watchlist to:'
                        isButton={true}
                        buttonData={[{ label: 'RENAME', action: onRenameWatchlist }]}
                    />


                </>
                :
                <>
                    <EmptyWatchlistModal
                        mutualFund={allMutualFunds}
                        nfo={nfo}
                        themes={themes}
                        mutualFundsScrips={mutualFundsScrips}
                        setMutualFundsScrips={setMutualFundsScrips}
                        fundList={fundList}
                        setFundList={setFundList}
                        currentWatchListName={currentWatchListName}
                        setCurrentWatchListName={setCurrentWatchListName}
                        arrWatchlist={arrWatchlist}
                        setArrWatchlist={setArrWatchlist}
                    />

                </>
            }
            <BzToastMessage show={toasterMsgConfig.isShow} isButton={toasterMsgConfig.isButton} btnContent={toasterMsgConfig.btnContent} message={toasterMsgConfig.msg} btnClickHandler={btnClickHandler} />

        </>
    );
};

export default memo(Watchlist);
